import script from "./CreateGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateGroup.vue?vue&type=script&setup=true&lang=js"

import "./CreateGroup.vue?vue&type=style&index=0&id=607d11ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-607d11ab"]])

export default __exports__